import React from 'react'
import img1 from '../../../assets/images/secure_data.png'
import img2 from '../../../assets/images/functional.png'
import img3 from '../../../assets/images/live-chat.png'
import img4 from '../../../assets/images/support.png'
import img5 from '../../../assets/images/features_frame.png'

const Main = ({video}) => {
  return (
    <>
        {video ?
        <section className="row_am features_section video-features" id="features">
            <div className="container">
                <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                <h2><span>Features</span> that make us standout!</h2>
                <p>Accord is rich in features and functionality <br/> take a look below at some of our features.</p>
                </div>
                <div className="feature_detail">
                <div className="left_data feature_box">
                    <div className="data_block"  data-aos-duration="1500">
                    <div className="icon">
                        <img src="/assets/images/secure.png" alt="secure" />
                    </div>
                    <div className="text">
                        <h4>Secure data</h4>
                        <p>Accord provides full encryption front to back with multiple levels of security.</p>
                    </div>
                    </div>
                    <div className="data_block"  data-aos-duration="1500">
                    <div className="icon">
                        <img src="/assets/images/abt_functional.png" alt="abt_functional" />
                    </div>
                    <div className="text">
                        <h4>Fully functional</h4>
                        <p>Built with the latest technology and fully functional.</p>
                    </div>
                    </div>
                </div>
                <div className="right_data feature_box">
                    <div className="data_block"  data-aos-duration="1500">
                    <div className="icon">
                        <img src="/assets/images/communication.png" alt="communication"/>
                    </div>
                    <div className="text">
                        <h4>Live chat</h4>
                        <p>Need help? Accord provides built-in live real-time communications.</p>
                    </div>
                    </div>
                    <div className="data_block"  data-aos-duration="1500">
                    <div className="icon">
                        <img src="/assets/images/abt_support.png" alt="abt_support" />
                    </div>
                    <div className="text">
                        <h4>24-7 Support</h4>
                        <p>24-7/365 support, we aim to respond within hours not days!.</p>
                    </div>
                    </div>
                </div>
                <div className="feature_img"  data-aos-duration="1500" data-aos-delay="100">
                    <img src="/assets/images/features_frame.png" alt="features_frame" />
                </div>
                </div>
            </div>
        </section>
        :
        <section className="row_am features_section" id="features">
            <div className="container">
                <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                <h2><span>Features</span> that make us standout!</h2>
                <p>Accord is rich in features and functionality <br/> take a look below at some of our features</p>
                </div>
                <div className="feature_detail">
                <div className="left_data feature_box">
                    <div className="data_block"  data-aos-duration="1500">
                    <div className="icon">
                        <img src={img1} alt="secure" />
                    </div>
                    <div className="text">
                        <h4>Secure data</h4>
                      <p>Accord provides full encryption front to back with multiple levels of security.</p>
                    </div>
                    </div>
                    <div className="data_block"  data-aos-duration="1500">
                    <div className="icon">
                        <img src={img2} alt="functional" />
                    </div>
                    <div className="text">
                        <h4>Fully functional</h4>
                      <p>Built with the latest technology and fully functional.</p>
                    </div>
                    </div>
                </div>
                <div className="right_data feature_box">
                    <div className="data_block"  data-aos-duration="1500">
                    <div className="icon">
                        <img src={img3} alt="live chat"/>
                    </div>
                    <div className="text">
                        <h4>Live chat</h4>
                      <p>Need help? Accord provides built-in live real-time communications.</p>
                    </div>
                    </div>
                    <div className="data_block"  data-aos-duration="1500">
                    <div className="icon">
                        <img src={img4} alt="24-7 support" />
                    </div>
                    <div className="text">
                        <h4>24-7 Support</h4>
                      <p>24-7/365 support, we aim to respond within hours not days!.</p>
                    </div>
                    </div>
                </div>
                <div className="feature_img"  data-aos-duration="1500" data-aos-delay="100">
                    <img src={img5} alt="feature_img" />
                </div>
                </div>
            </div>
        </section>}
    </>
  )
}

export default Main